import React, { ChangeEvent } from "react";
import { JSONFieldEditorProps } from "../enums";
import { validateInput } from "./utils";

export const JSONFieldEditor: React.FC<JSONFieldEditorProps> = ({
    jsonValue,
    fieldType,
    operator,
    isValid,
    setIsValid,
    handleOnChange,
}) => {
    const searchIn = jsonValue?.search_in || '';
    const valueContent = jsonValue?.value || '';

    const handleSearchInChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = {
            ...jsonValue,
            search_in: e.target.value,
        };
        handleOnChange(newValue);
    };

    const handleValueChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = {
            ...jsonValue,
            value: e.target.value,
        };
        setIsValid(validateInput(newValue, fieldType, operator));
        handleOnChange(newValue);
    };

    return (
        <div className="qf-json-editor">
            <input
                type="text"
                value={searchIn}
                onChange={handleSearchInChange}
                className="qf-json-editor__input"
                placeholder="Искать в"
            />
            <input
                type="text"
                value={valueContent}
                onChange={handleValueChange}
                className={`qf-json-editor__input${!isValid ? ' is-invalid' : ''}`}
                placeholder="Значение"
            />
        </div>
    );
};
